import { render, staticRenderFns } from "./VendorInspectionsList.vue?vue&type=template&id=6ce0ccb8&scoped=true&"
import script from "./VendorInspectionsList.vue?vue&type=script&lang=js&"
export * from "./VendorInspectionsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce0ccb8",
  null
  
)

export default component.exports